import React, { useState } from 'react';
import homebanner from '../assets/HomeBannerLatest.png';

interface HeroBannerProps {
  onBookNow?: () => void;
}

const HeroBanner: React.FC<HeroBannerProps> = ({ onBookNow }) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <div className="w-full overflow-hidden rounded-xl shadow-lg mb-6 bg-white">
      {/* Banner Image */}
      <div className="w-full">
        {!imageLoaded && (
          <div className="w-full bg-gray-200 animate-pulse" style={{ aspectRatio: '16/9' }} />
        )}
        <img
          src={homebanner}
          alt="minto - Doorstep Mobile Repair Service in Mumbai"
          className={`w-full h-auto object-cover ${imageLoaded ? 'block' : 'hidden'}`}
          width={1200}
          height={675}
          decoding="async"
          fetchPriority="high"
          onLoad={() => setImageLoaded(true)}
        />
      </div>

      {/* Content Below Banner */}
      <div className="px-5 py-4 md:px-8 md:py-5 bg-gradient-to-r from-minto-600 to-minto-700">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div>
            {/* Heading */}
            <h1 className="text-white text-xl md:text-2xl font-bold leading-tight mb-1">
              Phone Repair <span className="text-minto-200">Ab Minto Mein</span>
            </h1>

            {/* USP Pills */}
            <div className="flex flex-wrap gap-2 mt-2">
              <span className="inline-flex items-center gap-1 bg-white/15 text-white text-xs px-2.5 py-1 rounded-full">
                <i className="fas fa-home text-[10px]"></i> Doorstep Service in 30 Minutes
              </span>
              <span className="inline-flex items-center gap-1 bg-white/15 text-white text-xs px-2.5 py-1 rounded-full">
                <i className="fas fa-shield-alt text-[10px]"></i> 6 Months Warranty
              </span>
            </div>
          </div>

          {/* CTA Button */}
          <button
            onClick={onBookNow}
            className="inline-flex items-center justify-center gap-2 bg-white text-minto-600 font-semibold text-sm md:text-base px-6 py-3 rounded-lg shadow-md hover:shadow-lg transition-all active:scale-95 whitespace-nowrap"
          >
            <i className="fas fa-wrench"></i>
            Book Repair Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default HeroBanner;
